var mtc_page = {type: ''};

/* functions for slide menu  */

function setroot(label) {
    $.cookie('shop_root', label, {secure: 0, expires: 365, path: '/'});
    var ele = $('#category_root');
    if (ele.attr('disabled')) {
        ele.removeAttr('disabled');
    }
    ele.val(label);
}

function setsale(label) {
    var ele = $('#category_sale');
    if (ele.attr('disabled')) {
        ele.removeAttr('disabled');
    }
    ele.val('1');
}

function setbrands(brands) {
    var ele = $('#category_brands');
    if (ele.attr('disabled')) {
        ele.removeAttr('disabled');
    }
    ele.val(brands);
}

function setcategory(item) {
    var ele = $('#category_items');
    if (ele.attr('disabled')) {
        ele.removeAttr('disabled');
    }
    ele.val(item);
}

function setsize(size) {
    var ele = $('#category_szcol');
    if (ele.attr('disabled')) {
        ele.removeAttr('disabled');
    }
    ele.val(size);
}

function onroot(label) {
    setroot(label);
    document.clkcat.submit();
}

function onsale(label) {
    setroot(label);
    setsale();
    document.clkcat.submit();
}

function onbrands(label, brands) {
    setroot(label);
    setbrands(brands);
    document.clkcat.submit();
}

function oncategory(label, item) {
    setroot(label);
    setcategory(item);
    document.clkcat.submit();
}

function onitem(item) {
    setcategory(item);
    document.clkcat.submit();
}

function oncomposite(brands, item) {
    setcategory(item);
    setbrands(brands);
    document.clkcat.submit();
}

function onsize(cat, size) {
    setsize(size);
    setroot(cat);
    document.clkcat.submit();
}

function onkeybtn() {
    $('#clksearch').children('#keyword').val($('#h-search').children('#keyword').val());
    document.clkcat.submit();
}

function onkeyword(evt) {
    var k;
    var e;
    if (window.event) {
        e = window.event;
    } else {
        e = evt;
    }
    if (document.all)
        k = e.keyCode;
    else if (document.getElementById)
        k = (e.keyCode) ? e.keyCode : e.charCode;
    else if (document.layers)
        k = e.which;

    if (k == 0x0d) {
        $('#clksearch').children('#keyword').val($('#h-search').children('#keyword').val());
        document.clkcat.submit();
    }
    return true;
}

var mtc_menu_funcs = {
    onroot: function (label) {
        onroot(label);
    },
    onsale: function (label) {
        onsale(label);
    },
    onbrands: function (label, brands) {
        onbrands(label, brands);
    },
    oncategory: function (label, item) {
        oncategory(label, item);
    },
    onitem: function (item) {
        onitem(item);
    },
    oncomposite: function (brands, item) {
        oncomposite(brands, item);
    },
    onsize: function (cat, size) {
        onsize(cat, size);
    },
    onkeybtn: function () {
        onkeybtn();
    },
    onkeyword: function (evt) {
        onkeyword(evt);
    },
    invoke: function ($elem) {
        if (!$elem) return false;
        var fname = $elem.data('func');
        if (!fname || !this[fname]) {
            return false;
        }
        var args = $elem.data('args');
        if (!args) {
            return false;
        }
        var args_arr = args.split(/\s*,\s*!/);
        for (var i = 0; i < args_arr.length; i++) {
            args_arr[i] = args_arr[i].replace(/^\s+|\s+$/g, '');
            args_arr[i] = args_arr[i].replace(/^'|'$/g, '');
        }
        this[fname].apply(this, args_arr);
        return true;
    }

};

$(document).ready(function utility(event) {

    //スライダー読み込み
    // $(".slider").bxSlider();
    $(document).ready(function () {
        var mySwiper = new Swiper('.slider', {
            pagination: '.pager_dots',
            spaceBetween: 20,
            loop: true
        })
    });

    //検索窓展開
    $("div.search input.search_icon").click(function () {
        if ($("div.search").hasClass("close")) {
            $("div.search").addClass("open").removeClass("close");
            $("header nav").addClass("search");
            return false;
        }
    });

    //ハンバーガー用
    $("a.sp_nav_menu").html("<span></span><span></span><span></span>");
    //ナビクローズ用
    $("nav.slide_nav div > ul").prepend("<li><a href='#' class='close'>close</a></li>");

    //ナビオープン
    $("a.sp_nav_menu").click(function () {
        $(".slide_nav div.slide_wrapper").css({"transform": "translate(0,0)"});
        $("body").addClass("nav_open");
        $(".nav_overlay").show();
        console.log("overlay show");
        var bh = $("body").height();
        var wh = $(window).height();
        if (wh > bh) {
            $(".nav_overlay").height(wh);
        }
        if ($("header nav").hasClass("search")) {
            $("header nav").removeClass("search");
            $("div.search").addClass("close").removeClass("open");
        }
        return false;
    });

    // デスクトップ: Splideカルーセルの再レイアウト用resize発火
    function triggerResizeForFilter() {
        if (window.innerWidth < 1200) return;
        window.dispatchEvent(new Event('resize'));
    }

    //フィルタートグル (イベント委譲: AJAX後のDOM差し替えに対応)
    $(document).on("click", "nav.filters a, .filter-toggle-chip", function () {
        if ($("body").hasClass("filters_open")) {
            // 既に開いていれば閉じる
            $("body").removeClass("filters_open");
            triggerResizeForFilter();
            $(".nav_overlay").hide();
        } else {
            // 閉じていれば開く
            // CSSが body.filters_open に反応して .collection の margin-right を変更するため
            // クラス付与後に resize を発火してSplideを再レイアウトさせる
            $("body").addClass("filters_open");
            triggerResizeForFilter();
            $(".nav_overlay").show();
            console.log("overlay show");
            var bh = $("body").height();
            var wh = $(window).height();
            if (wh > bh) {
                $(".nav_overlay").height(wh);
            }
            if ($("header nav").hasClass("search")) {
                $("header nav").removeClass("search");
                $("div.search").addClass("close").removeClass("open");
            }
        }
        return false;
    });

    //フィルタートグル設定:
    // 直下の見出しリンク(href="#")のみトグル対象にし、配下の実リンク遷移は阻害しない
    $(document).on("click", ".filter_select > a[href='#']", function () {
        if ($(this).parent().hasClass("close")) {
            $(this).parent().removeClass("close").addClass("open");
        } else if ($(this).parent().hasClass("open")) {
            $(this).parent().removeClass("open").addClass("close");
        }
        return false;
    });

    //ナビ深度
    var navdepth = 1;
    var navwidth = $(".slide_nav").width();

    //ナビクリック
    $(".slide_nav ul li a").click(function () {
        var tgt = $(this).attr("href");
        var child;
        if (tgt.length > 2 && tgt.match(/#/)) {
            child = tgt.substr(1);
            var navleft = navwidth * navdepth;
            navdepth += 1;
            if ($("div." + child + "").length == 0) {
                //var handled = mtc_menu_funcs.invoke($(this));
                console.log(handled);
                //return !handled;
            }
            $("div.dpt" + navdepth + "").hide();
            $("div." + child + "").show();
            //$(".slide_nav div").animate({marginLeft:"-"+navleft+"px"},250);
            $(".slide_nav div.slide_wrapper").css({"transform": "translate(-" + navleft + "px,0)"});
            //return false;
        }
        //return !mtc_menu_funcs.invoke($(this));
    });

    //戻るボタン
    $(".slide_nav ul li strong").click(function () {
        navdepth -= 1;
        var navleft = navwidth * (navdepth - 1);
        //$(".slide_nav div").animate({marginLeft:"-"+navleft+"px"},250);
        $(".slide_nav div.slide_wrapper").css({"transform": "translate(-" + navleft + "px,0)"});
        $(this).closest("ul").css("z-index", "10");
    });

    //コンテンツ枠クリック
    $(".nav_overlay,.slide_nav a.close").click(function () {
        if ($("body").hasClass("nav_open")) {
            $("body").removeClass("nav_open");
            navdepth = 1;
            $(".nav_overlay").hide();
            console.log("overlay hide");
        } else if ($("body").hasClass("filters_open")) {
            $("body").removeClass("filters_open");
            $(".nav_overlay").hide();
            console.log("overlay hide");
        }
        return false;
    });

    //ナビゲーション アルファベット指定開閉
    $("ul.alphabet li a").click(function () {
        var alphabet = $(this).html();
        var tgt = $(this).attr("href");
        var child = tgt.substr(1);
        $("nav.slide_nav li.toggle").removeClass().addClass("toggle close");
        $("div." + child + " li.toggle[alphabet='" + alphabet + "']").removeClass("close").addClass("open");
        var posY = $("div." + child + " li.toggle[alphabet='" + alphabet + "']").offset().top;
        $(".slide_nav div").scrollTop(posY);
        return false;
    });

    //説明文開閉
    $(".toggle a").click(function () {
        $(".toggle").stop();
    });
    $(".toggle").click(function prtoggle() {
        var me;
        if ($(this).hasClass("toggle")) {
            me = $(this);
        } else if ($(this).closest(".toggle")) {
            me = $(this).closest(".toggle");
        }
        if ($(this).hasClass("close") || $(this).closest(".toggle").hasClass("close")) {
            me.removeClass("close").addClass("open");
        } else if ($(this).hasClass("open") || $(this).closest(".toggle").hasClass("open")) {
            me.removeClass("open").addClass("close");
            me.scrollTop("0");
        }
    });


    //スワイプ設定
    $('.wrapper').on('touchstart', onTouchStart); //指が触れたか検知
    $('.wrapper').on('touchmove', onTouchMove); //指が動いたか検知
    $('.wrapper').on('touchend', onTouchEnd); //指が離れたか検知
    var direction, position;
    var interval = 200;
    var lastTime;

    //スワイプ開始時の横方向の座標を格納
    function onTouchStart(event) {
        position = getPosition(event);
        direction = ''; //一度リセットする
    }

    //スワイプの方向（left／right）を取得
    function onTouchMove(event) {
        if (position - getPosition(event) > 100) { // 70px以上移動しなければスワイプと判断しない
            direction = 'left'; //左と検知
        } else if (position - getPosition(event) < -100) {// 70px以上移動しなければスワイプと判断しない
            direction = 'right'; //右と検知
        } else {
            direction = '';
        }
    }

    function onTouchEnd(event) {
        if (direction == 'left' && $("body").hasClass("nav_open")) {
            $("body").removeClass("nav_open");
            navdepth = 1;
        } else if (direction == 'left' && $("body").hasClass("filters_open")) {
            $("body").removeClass("filters_open");
        }
        // $(".nav_overlay").hide();
    }

    //横方向の座標を取得
    function getPosition(event) {
        return event.originalEvent.touches[0].pageX;
    }

    // 別Windowで開くのを禁止する(temporary)
    $('ul.products li a[target="_blank"]').each(function (i, e) {
        $(e).removeAttr('target');
    });


});
